@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.ConfigTypePopOut {
  @extend %font-family-primary;

  width: 394px;
  max-height: 400px;
  border-radius: 8px;
  overflow: auto;
  padding: 16px;

  &.noFixWidth {
    width: auto;
  }
}
